import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store";
import { commonErrorMessage } from "../../../helpers/messages";
import dispatchNotification from "../actions/dispatchNotification";
import { getAssessments } from "../../../api/assessment";
import { AssessmentDocument } from "../../../interfaces/AssessmentInterfaces";
import GroupAssessmentsByDate from "../functions/assessment";
import { ASSESSMENT_SEARCH_BY } from "../../../containers/Assessment/AssessmentListSearch";

const useAssessments = (): {
  assessments: { [key: string]: AssessmentDocument[] };
  isLoading: boolean;
} => {
  const dispatch = useDispatch();
  const [assessments, setAssessments] = React.useState<AssessmentDocument[]>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const clientId = useSelector((state: RootState) => state.clientPortalUserInfo.user.user.id);
  React.useEffect(() => {
    (async () => {
      if (clientId) {
        try {
          setIsLoading(true);
          const responseData = await getAssessments({
            page: 0,
            pageSize: 10,
            searchBy: ASSESSMENT_SEARCH_BY.CLIENT,
            searchValue: String(clientId)
          });
          setAssessments(responseData.results);
        } catch {
          dispatchNotification.error(dispatch, commonErrorMessage);
          setIsLoading(false);
        } finally {
          setIsLoading(false);
        }
      }
    })();
  }, [clientId, dispatch]);

  return { assessments: GroupAssessmentsByDate(assessments), isLoading };
};

export default useAssessments;
